/**
 * Hinweis im Beleg, solange Clara ihn liest (oder wenn das Lesen scheiterte).
 * Seit 16.10.2026 liest Clara im Hintergrund — der Beleg ist schon offen,
 * während die Felder sich noch füllen.
 */
type Props = {
  laeuft: boolean;
  fehler?: string;
  /** Text, was gerade gelesen wird (Rechnung vs. Lieferschein) */
  was?: string;
  /** Überschrift, Standard „Clara liest den Beleg …" (private Dokumente: „das Dokument") */
  titel?: string;
  /** Satz danach, was man derweil schon tun kann */
  zusatz?: string;
  onNochmal?: () => void;
};

export default function ClaraHinweis({ laeuft, fehler, was, titel, zusatz, onNochmal }: Props) {
  if (!laeuft && !fehler) return null;
  return (
    <div
      role="status"
      style={{
        margin: "10px 0 0",
        padding: "12px 14px",
        borderRadius: 12,
        display: "flex",
        gap: 12,
        alignItems: "center",
        background: laeuft ? "var(--m-accent-soft, rgba(193,74,61,0.12))" : "rgba(214,161,74,0.14)",
        border: `1px solid ${laeuft ? "var(--m-accent, #c8643c)" : "rgba(214,161,74,0.55)"}`,
        color: "var(--m-ink)",
      }}
    >
      {laeuft ? (
        <span
          aria-hidden="true"
          style={{
            width: 18,
            height: 18,
            flex: "none",
            borderRadius: "50%",
            border: "2.5px solid var(--m-accent, #c8643c)",
            borderTopColor: "transparent",
            animation: "claraDreh .9s linear infinite",
          }}
        />
      ) : (
        <span aria-hidden="true" style={{ fontSize: 18, flex: "none" }}>⚠︎</span>
      )}
      <div style={{ flex: 1, minWidth: 0, fontSize: 13.5, lineHeight: 1.4 }}>
        {laeuft ? (
          <>
            <b>{titel || "Clara liest den Beleg …"}</b>
            <br />
            {was || "Lieferant, Datum und Betrag"} füllen sich gleich von selbst.{" "}
            {zusatz ?? "Projekt und Zahlweg kannst du schon wählen."}
          </>
        ) : (
          fehler
        )}
      </div>
      {!laeuft && onNochmal && (
        <button
          onClick={onNochmal}
          style={{
            flex: "none",
            minHeight: 40,
            padding: "0 12px",
            borderRadius: 10,
            border: "1px solid var(--m-line-2, rgba(0,0,0,.2))",
            background: "transparent",
            color: "var(--m-ink)",
            fontSize: 13,
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Noch einmal
        </button>
      )}
      <style>{`@keyframes claraDreh { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
